import React, { useEffect, useState, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  ButtonUploadFile,
  FileUpload,
  FileName,
} from "./ContentTabOfResources.styled";
import { IconButton } from "@material-ui/core";
import { ROLES } from "../../util/RolesConstants";

const ContentTabOfResources = ({
  tabSelected,
  handleUploadFile,
  files,
  userLoggedIn,
  handleDownloadFile,
}) => {
  const [adminGuide, setAdminGuide] = useState();
  const [agentGuide, setAgentGuide] = useState();
  const rAgentUpload = useRef();
  const rAdminUpload = useRef();
  useEffect(() => {
    if (files.length > 0) {
      files.forEach((f) => {
        if (f.resourceName === "Admin User Guide") {
          setAdminGuide(f);
        } else {
          setAgentGuide(f);
        }
      });
    } else {
      setAdminGuide();
      setAgentGuide();
    }
  }, [files]);

  const handleAgentFileUpload = () => {
    handleUploadFile(rAgentUpload?.current?.files[0], "Agent");
  };

  const handleAdminFileUpload = () => {
    handleUploadFile(rAdminUpload?.current?.files[0], "Admin");
  };

  const handleAgentUpload = () => {
    rAgentUpload.current.value = "";
    rAgentUpload.current.click();
  };

  const handleAdminUpload = () => {
    rAdminUpload.current.value = "";
    rAdminUpload.current.click();
  };

  return (
    <>
      {((adminGuide && userLoggedIn.roleId !== ROLES.AGENT && tabSelected !== "AboutWellness") || (adminGuide && userLoggedIn.roleId <= ROLES.COUNTRY_ADMIN && tabSelected !== "AboutWellness")) && (
          <>
            <Row>
              <Col md={3}>
                <ButtonUploadFile>
                  <ListAltIcon className="mx-2" />
                  Admin User guide
                </ButtonUploadFile>
              </Col>
              <Col md={6} className="mt-2">
                <FileName
                  onClick={() => handleDownloadFile(adminGuide?.fileName)}
                >
                  {adminGuide && adminGuide.fileName
                    ? adminGuide.fileName
                    : "Upload a file"}
                </FileName>
              </Col>
              <Col md={3}>
                {userLoggedIn.roleId <= ROLES.COUNTRY_ADMIN && (
                  <IconButton onClick={() => handleAdminUpload()}>
                    <AddCircleOutlineIcon />
                    <FileUpload
                      ref={rAdminUpload}
                      type="file"
                      accept="application/pdf"
                      onChange={() => handleAdminFileUpload()}
                    />
                  </IconButton>
                )}
              </Col>
            </Row>
            <hr />
          </>
        )}
      {(agentGuide || userLoggedIn.roleId <= ROLES.COUNTRY_ADMIN) && (
        <>
          <Row>
            <Col md={3}>
              <ButtonUploadFile>
                <ListAltIcon className="mx-2" />
                {tabSelected !== "AboutWellness"
                  ? "Agent User guide"
                  : "T&S Wellness handbook"}
              </ButtonUploadFile>
            </Col>
            <Col md={6} className="mt-2">
              <FileName
                onClick={() => handleDownloadFile(agentGuide?.fileName)}
              >
                {agentGuide && agentGuide.fileName
                  ? agentGuide.fileName
                  : "Upload a file"}
              </FileName>
            </Col>
            <Col md={3}>
              {userLoggedIn.roleId <= ROLES.COUNTRY_ADMIN && (
                <IconButton onClick={() => handleAgentUpload()}>
                  <AddCircleOutlineIcon />
                  <FileUpload
                    ref={rAgentUpload}
                    type="file"
                    accept="application/pdf"
                    onChange={() => handleAgentFileUpload()}
                  />
                </IconButton>
              )}
            </Col>
          </Row>
          <hr />
        </>
      )}
      {!adminGuide &&
        userLoggedIn.roleId > ROLES.COUNTRY_ADMIN &&
        !agentGuide &&
        userLoggedIn.roleId > ROLES.COUNTRY_ADMIN && (
          <p style={{ textAlign: "center" }}>No records found.</p>
        )}
    </>
  );
};

export default ContentTabOfResources;
